import React, { Fragment } from 'react';

const FootersUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row last">
        <div className="left">
          <h1 className="h1 page-title">
            Footer is located at the bottom of the page with useful information.
          </h1>
        </div>
        <div className="right">
          <p>The footer is a component used to display general information that a user might want to access from any page within the product. It usually contains links and action icons for an easy navigation through the product,  as well as an informative section.</p>
        </div>
      </article>
    </section>
    <section className="bg-grey flex-grow-1 with-padding">
      <article className="flex-row flex-justify-end">
        <div className="right copy-content">
          <h2 className="h2 page-subtitle">Standard Footer</h2>
          <p>This is the simplest footer, containing only a link to the help center, an informative section, and an action icon to go back to the top of the page.</p>
          <h2 className="h2 page-subtitle">Product Landing Page Footer</h2>
          <p>This footer contains two links, the informative section and adds action icons for all the social media that might interest the user.</p>
          <h2 className="h2 page-subtitle">Standard Landing Page Footer</h2>
          <p>The most complete of all the footers with two levels of information. On the first one, the user can find an extensive list of link that will lead him to where he is looking to go, as well some other action icons. On the second level, there are some informative links as well as an informative section.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default FootersUsage;


// WEBPACK FOOTER //
// ./src/containers/components/Footer/FootersUsage.js